module.exports = __webpack_public_path__ + "static/media/managebook.63dad186.svg";